(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3467,6136,152],{

/***/ 53765:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apps/email",
      function () {
        return __webpack_require__(49338);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1954);
// ** Icon Imports


const IconifyIcon = (param)=>{
    let { icon , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
        icon: icon,
        fontSize: "1.5rem",
        ...rest
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconifyIcon);


/***/ }),

/***/ 92024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Avatar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69661);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41796);
/* harmony import */ var src_core_hooks_useBgColor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19550);
// ** React Imports


// ** MUI Imports


// ** Hooks Imports

const Avatar = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref)=>{
    // ** Props
    const { sx , src , skin , color  } = props;
    // ** Hook
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const bgColors = (0,src_core_hooks_useBgColor__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const getAvatarStyles = (skin, skinColor)=>{
        let avatarStyles;
        if (skin === "light") {
            avatarStyles = {
                ...bgColors["".concat(skinColor, "Light")]
            };
        } else if (skin === "light-static") {
            avatarStyles = {
                color: bgColors["".concat(skinColor, "Light")].color,
                backgroundColor: (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_4__/* .lighten */ .$n)(theme.palette[skinColor].main, 0.88)
            };
        } else {
            avatarStyles = {
                ...bgColors["".concat(skinColor, "Filled")]
            };
        }
        return avatarStyles;
    };
    const colors = {
        primary: getAvatarStyles(skin, "primary"),
        secondary: getAvatarStyles(skin, "secondary"),
        success: getAvatarStyles(skin, "success"),
        error: getAvatarStyles(skin, "error"),
        warning: getAvatarStyles(skin, "warning"),
        info: getAvatarStyles(skin, "info")
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Avatar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        ref: ref,
        ...props,
        sx: !src && skin && color ? Object.assign(colors[color], sx) : sx
    });
});
Avatar.defaultProps = {
    skin: "filled",
    color: "primary"
};
/* harmony default export */ __webpack_exports__["Z"] = (Avatar);


/***/ }),

/***/ 35276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Chip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87918);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var src_core_hooks_useBgColor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19550);
// ** MUI Imports


// ** Third Party Imports

// ** Hooks Imports

const Chip = (props)=>{
    // ** Props
    const { sx , skin , color , rounded  } = props;
    // ** Hook
    const bgColors = (0,src_core_hooks_useBgColor__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    const colors = {
        primary: {
            ...bgColors.primaryLight
        },
        secondary: {
            ...bgColors.secondaryLight
        },
        success: {
            ...bgColors.successLight
        },
        error: {
            ...bgColors.errorLight
        },
        warning: {
            ...bgColors.warningLight
        },
        info: {
            ...bgColors.infoLight
        }
    };
    const propsToPass = {
        ...props
    };
    propsToPass.rounded = undefined;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Chip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        ...propsToPass,
        variant: "filled",
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            "MuiChip-rounded": rounded,
            "MuiChip-light": skin === "light"
        }),
        sx: skin === "light" && color ? Object.assign(colors[color], sx) : sx
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Chip);


/***/ }),

/***/ 4560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5616);
/* harmony import */ var _mui_material_Menu__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35294);
/* harmony import */ var _mui_material_Divider__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67720);
/* harmony import */ var _mui_material_MenuItem__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18972);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93946);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61906);
/* harmony import */ var src_core_components_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21609);
/* harmony import */ var src_core_hooks_useSettings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51514);
// ** React Imports


// ** Next Import

// ** MUI Imports






// ** Icon Imports

// ** Hook Import

const MenuItemWrapper = (param)=>{
    let { children , option  } = param;
    if (option.href) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            component: (next_link__WEBPACK_IMPORTED_MODULE_2___default()),
            href: option.href,
            ...option.linkProps,
            sx: {
                px: 4,
                py: 1.5,
                width: "100%",
                display: "flex",
                color: "inherit",
                alignItems: "center",
                textDecoration: "none"
            },
            children: children
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: children
        });
    }
};
const OptionsMenu = (props)=>{
    // ** Props
    const { icon , options , menuProps , iconProps , leftAlignMenu , iconButtonProps  } = props;
    // ** State
    const [anchorEl, setAnchorEl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    // ** Hook & Var
    const { locale  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    const { settings  } = (0,src_core_hooks_useSettings__WEBPACK_IMPORTED_MODULE_5__/* .useSettings */ .r)();
    const { direction  } = settings;
    const [arrowDown, setArrowDown] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
        setArrowDown(!arrowDown);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
        setArrowDown(true);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                "aria-haspopup": "true",
                onClick: handleClick,
                ...iconButtonProps,
                children: [
                    icon ? icon : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        icon: "mdi:dots-vertical",
                        ...iconProps
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "current-language",
                        style: {
                            fontWeight: "600",
                            fontSize: "14px",
                            textTransform: "capitalize"
                        },
                        children: [
                            locale || "en",
                            " "
                        ]
                    }),
                    arrowDown ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        icon: "ic:round-keyboard-arrow-down"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        icon: "ic:round-keyboard-arrow-up"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Menu__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                keepMounted: true,
                anchorEl: anchorEl,
                onClose: handleClose,
                open: Boolean(anchorEl),
                ...!leftAlignMenu && {
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: direction === "ltr" ? "right" : "left"
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: direction === "ltr" ? "right" : "left"
                    }
                },
                ...menuProps,
                children: options.map((option, index)=>{
                    if (typeof option === "string") {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_MenuItem__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            onClick: handleClose,
                            children: option
                        }, index);
                    } else if ("divider" in option) {
                        return option.divider && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Divider__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            ...option.dividerProps
                        }, index);
                    } else {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_MenuItem__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            ...option.menuItemProps,
                            ...option.href && {
                                sx: {
                                    p: 0
                                }
                            },
                            onClick: (e)=>{
                                handleClose();
                                option.menuItemProps && option.menuItemProps.onClick ? option.menuItemProps.onClick(e) : null;
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(MenuItemWrapper, {
                                option: option,
                                children: [
                                    option.icon ? option.icon : null,
                                    option.text
                                ]
                            })
                        }, index);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OptionsMenu);


/***/ }),

/***/ 31283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84808);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5616);
// ** React Imports


// ** MUI Imports


const Sidebar = (props)=>{
    // ** Props
    const { sx , show , direction , children , hideBackdrop , onOpen , onClose , backDropClick  } = props;
    const handleBackdropClick = ()=>{
        if (backDropClick) {
            backDropClick();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (show && onOpen) {
            onOpen();
        }
        if (show === false && onClose) {
            onClose();
        }
    }, [
        onClose,
        onOpen,
        show
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                sx: {
                    top: 0,
                    height: "100%",
                    zIndex: "drawer",
                    position: "absolute",
                    transition: "all 0.25s ease-in-out",
                    backgroundColor: "background.paper",
                    ...show ? {
                        opacity: 1
                    } : {
                        opacity: 0
                    },
                    ...direction === "right" ? {
                        left: "auto",
                        right: show ? 0 : "-100%"
                    } : {
                        right: "auto",
                        left: show ? 0 : "-100%"
                    },
                    ...sx
                },
                children: children
            }),
            hideBackdrop ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                open: show,
                transitionDuration: 250,
                onClick: handleBackdropClick,
                sx: {
                    position: "absolute",
                    zIndex: (theme)=>theme.zIndex.drawer - 1
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Sidebar);
Sidebar.defaultProps = {
    direction: "left"
};


/***/ }),

/***/ 66136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SettingsConsumer": function() { return /* binding */ SettingsConsumer; },
/* harmony export */   "SettingsContext": function() { return /* binding */ SettingsContext; },
/* harmony export */   "SettingsProvider": function() { return /* binding */ SettingsProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30152);
// ** React Imports


// ** ThemeConfig Import

const initialSettings = {
    themeColor: "primary",
    mode: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].mode,
    skin: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].skin,
    footer: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].footer,
    layout: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].layout,
    lastLayout: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].layout,
    direction: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].direction,
    navHidden: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].navHidden,
    appBarBlur: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].appBarBlur,
    navCollapsed: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].navCollapsed,
    contentWidth: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].contentWidth,
    toastPosition: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].toastPosition,
    verticalNavToggleType: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].verticalNavToggleType,
    appBar: src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].layout === "horizontal" && src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].appBar === "hidden" ? "fixed" : src_configs_themeConfig__WEBPACK_IMPORTED_MODULE_2__["default"].appBar
};
const staticSettings = {
    appBar: initialSettings.appBar,
    footer: initialSettings.footer,
    layout: initialSettings.layout,
    navHidden: initialSettings.navHidden,
    lastLayout: initialSettings.lastLayout,
    toastPosition: initialSettings.toastPosition
};
const restoreSettings = ()=>{
    let settings = null;
    try {
        const storedData = window.localStorage.getItem("settings");
        if (storedData) {
            settings = {
                ...JSON.parse(storedData),
                ...staticSettings
            };
        } else {
            settings = initialSettings;
        }
    } catch (err) {
        ;
    }
    return settings;
};
// set settings in localStorage
const storeSettings = (settings)=>{
    const initSettings = Object.assign({}, settings);
    delete initSettings.appBar;
    delete initSettings.footer;
    delete initSettings.layout;
    delete initSettings.navHidden;
    delete initSettings.lastLayout;
    delete initSettings.toastPosition;
    window.localStorage.setItem("settings", JSON.stringify(initSettings));
};
// ** Create Context
const SettingsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    saveSettings: ()=>null,
    settings: initialSettings
});
const SettingsProvider = (param)=>{
    let { children , pageSettings  } = param;
    // ** State
    const [settings, setSettings] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        ...initialSettings
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const restoredSettings = restoreSettings();
        if (restoredSettings) {
            setSettings({
                ...restoredSettings
            });
        }
        if (pageSettings) {
            setSettings({
                ...settings,
                ...pageSettings
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageSettings
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (settings.layout === "horizontal" && settings.mode === "semi-dark") {
            saveSettings({
                ...settings,
                mode: "light"
            });
        }
        if (settings.layout === "horizontal" && settings.appBar === "hidden") {
            saveSettings({
                ...settings,
                appBar: "fixed"
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        settings.layout
    ]);
    const saveSettings = (updatedSettings)=>{
        storeSettings(updatedSettings);
        setSettings(updatedSettings);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SettingsContext.Provider, {
        value: {
            settings,
            saveSettings
        },
        children: children
    });
};
const SettingsConsumer = SettingsContext.Consumer;


/***/ }),

/***/ 19550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2734);
/* harmony import */ var src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5026);
// ** MUI Imports

// ** Util Import

const UseBgColor = ()=>{
    // ** Hooks
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    return {
        primaryFilled: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main
        },
        primaryLight: {
            color: theme.palette.primary.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.primary.main, 0.12)
        },
        secondaryFilled: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.main
        },
        secondaryLight: {
            color: theme.palette.secondary.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.secondary.main, 0.12)
        },
        successFilled: {
            color: theme.palette.success.contrastText,
            backgroundColor: theme.palette.success.main
        },
        successLight: {
            color: theme.palette.success.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.success.main, 0.12)
        },
        errorFilled: {
            color: theme.palette.error.contrastText,
            backgroundColor: theme.palette.error.main
        },
        errorLight: {
            color: theme.palette.error.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.error.main, 0.12)
        },
        warningFilled: {
            color: theme.palette.warning.contrastText,
            backgroundColor: theme.palette.warning.main
        },
        warningLight: {
            color: theme.palette.warning.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.warning.main, 0.12)
        },
        infoFilled: {
            color: theme.palette.info.contrastText,
            backgroundColor: theme.palette.info.main
        },
        infoLight: {
            color: theme.palette.info.main,
            backgroundColor: (0,src_core_utils_hex_to_rgba__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGBA */ .E)(theme.palette.info.main, 0.12)
        }
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (UseBgColor);


/***/ }),

/***/ 51514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useSettings; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_core_context_settingsContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66136);


const useSettings = ()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_core_context_settingsContext__WEBPACK_IMPORTED_MODULE_1__.SettingsContext);


/***/ }),

/***/ 83552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ getInitials; }
/* harmony export */ });
// ** Returns initials from string
const getInitials = (string)=>string.split(/\s/).reduce((response, word)=>response += word.slice(0, 1), "");


/***/ }),

/***/ 5026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ hexToRGBA; }
/* harmony export */ });
/**
 ** Hex color to RGBA color
 */ const hexToRGBA = (hexCode, opacity)=>{
    let hex = hexCode.replace("#", "");
    if (hex.length === 3) {
        hex = "".concat(hex[0]).concat(hex[0]).concat(hex[1]).concat(hex[1]).concat(hex[2]).concat(hex[2]);
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(opacity, ")");
};


/***/ }),

/***/ 30152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Config
 * -------------------------------------------------------------------------------------
 * ! IMPORTANT: Make sure you clear the browser local storage in order to see the config changes in the template.
 * ! To clear local storage, you may refer https://www.leadshook.com/help/how-to-clear-local-storage-in-google-chrome-browser/.
 */ const themeConfig = {
    // ** Layout Configs
    templateName: "Msafely" /* App Name */ ,
    layout: "vertical" /* vertical | horizontal */ ,
    mode: "light" /* light | dark | semi-dark /*! Note: semi-dark value will only work for Vertical Layout */ ,
    direction: "ltr" /* ltr | rtl */ ,
    skin: "default" /* default | bordered */ ,
    contentWidth: "boxed" /* full | boxed */ ,
    footer: "static" /* fixed | static | hidden */ ,
    // ** Routing Configs
    routingLoader: false,
    // ** Navigation (Menu) Configs
    navHidden: false,
    menuTextTruncate: true,
    navSubItemIcon: "mdi:circle" /* Icon */ ,
    verticalNavToggleType: "accordion" /* accordion | collapse /*! Note: This is for Vertical navigation menu only */ ,
    navCollapsed: false,
    navigationSize: 300 /* Number in px(Pixels) /*! Note: This is for Vertical navigation menu only */ ,
    collapsedNavigationSize: 68 /* Number in px(Pixels) /*! Note: This is for Vertical navigation menu only */ ,
    afterVerticalNavMenuContentPosition: "fixed" /* fixed | static */ ,
    beforeVerticalNavMenuContentPosition: "fixed" /* fixed | static */ ,
    horizontalMenuToggle: "hover" /* click | hover /*! Note: This is for Horizontal navigation menu only */ ,
    horizontalMenuAnimation: true,
    // ** AppBar Configs
    appBar: "fixed" /* fixed | static | hidden /*! Note: hidden value will only work for Vertical Layout */ ,
    appBarBlur: true,
    // ** Other Configs
    responsiveFontSizes: true,
    disableRipple: false,
    disableCustomizer: false,
    toastPosition: "top-right" /* top-left | top-center | top-right | bottom-left | bottom-center | bottom-right */ 
};
/* harmony default export */ __webpack_exports__["default"] = (themeConfig);


/***/ }),

/***/ 49338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ apps_email; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./src/@core/hooks/useSettings.js
var useSettings = __webpack_require__(51514);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/Input/Input.js
var Input = __webpack_require__(79332);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(69661);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(34386);
// EXTERNAL MODULE: ./node_modules/@mui/material/Backdrop/Backdrop.js + 1 modules
var Backdrop = __webpack_require__(84808);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(46483);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(87109);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 3 modules
var ListItem = __webpack_require__(97212);
// EXTERNAL MODULE: ./src/@core/components/icon/index.js
var icon = __webpack_require__(21609);
// EXTERNAL MODULE: ./node_modules/react-perfect-scrollbar/lib/index.js
var lib = __webpack_require__(51964);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./src/@core/components/option-menu/index.js
var option_menu = __webpack_require__(4560);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/timers-browserify/main.js
var main = __webpack_require__(602);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(48885);
// EXTERNAL MODULE: ./src/@core/components/sidebar/index.js
var sidebar = __webpack_require__(31283);
// EXTERNAL MODULE: ./src/@core/components/mui/chip/index.js
var chip = __webpack_require__(35276);
;// CONCATENATED MODULE: ./src/views/apps/email/MailDetails.js
// ** React Imports


// ** MUI Imports









// ** Icon Imports

// ** Third Party Imports

// ** Hooks

// ** Custom Components Imports



const HiddenReplyBack = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        height: 11,
        width: "90%",
        opacity: 0.5,
        borderWidth: 1,
        borderBottom: 0,
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        borderStyle: "solid",
        borderColor: theme.palette.divider,
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.paper
    };
});
const HiddenReplyFront = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        height: 12,
        width: "95%",
        opacity: 0.7,
        borderWidth: 1,
        borderBottom: 0,
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        borderStyle: "solid",
        borderColor: theme.palette.divider,
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.paper
    };
});
const MailDetails = (props)=>{
    // ** Props
    const { mail , hidden , folders , dispatch , direction , updateMail , foldersObj , labelColors , routeParams , paginateMail , handleStarMail , mailDetailsOpen , handleLabelUpdate , handleFolderUpdate , setMailDetailsOpen  } = props;
    // ** State
    const [showReplies, setShowReplies] = (0,react.useState)(false);
    // ** Hook
    const { settings  } = (0,useSettings/* useSettings */.r)();
    const handleMoveToTrash = ()=>{
        dispatch(updateMail({
            emailIds: [
                mail.id
            ],
            dataToUpdate: {
                folder: "trash"
            }
        }));
        setMailDetailsOpen(false);
    };
    const handleReadMail = ()=>{
        dispatch(updateMail({
            emailIds: [
                mail.id
            ],
            dataToUpdate: {
                isRead: false
            }
        }));
        setMailDetailsOpen(false);
    };
    const handleLabelsMenu = ()=>{
        const array = [];
        Object.entries(labelColors).map((param)=>{
            let [key, value] = param;
            array.push({
                text: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    sx: {
                        textTransform: "capitalize"
                    },
                    children: key
                }),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    component: "span",
                    sx: {
                        mr: 2,
                        color: "".concat(value, ".main")
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                        icon: "mdi:circle",
                        fontSize: "0.75rem"
                    })
                }),
                menuItemProps: {
                    onClick: ()=>{
                        handleLabelUpdate([
                            mail.id
                        ], key);
                        setMailDetailsOpen(false);
                    }
                }
            });
        });
        return array;
    };
    const handleFoldersMenu = ()=>{
        const array = [];
        if (routeParams && routeParams.folder && !routeParams.label && foldersObj[routeParams.folder]) {
            foldersObj[routeParams.folder].map((folder)=>{
                array.length = 0;
                array.push({
                    icon: folder.icon,
                    text: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            textTransform: "capitalize"
                        },
                        children: folder.name
                    }),
                    menuItemProps: {
                        onClick: ()=>{
                            handleFolderUpdate(mail.id, folder.name);
                            setMailDetailsOpen(false);
                        }
                    }
                });
            });
        } else if (routeParams && routeParams.label) {
            folders.map((folder)=>{
                array.length = 0;
                array.push({
                    icon: folder.icon,
                    text: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            textTransform: "capitalize"
                        },
                        children: folder.name
                    }),
                    menuItemProps: {
                        onClick: ()=>{
                            handleFolderUpdate(mail.id, folder.name);
                            setMailDetailsOpen(false);
                        }
                    }
                });
            });
        } else {
            foldersObj["inbox"].map((folder)=>{
                array.length = 0;
                array.push({
                    icon: folder.icon,
                    text: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            textTransform: "capitalize"
                        },
                        children: folder.name
                    }),
                    menuItemProps: {
                        onClick: ()=>{
                            handleFolderUpdate(mail.id, folder.name);
                            setMailDetailsOpen(false);
                        }
                    }
                });
            });
        }
        return array;
    };
    const prevMailIcon = direction === "rtl" ? "mdi:chevron-right" : "mdi:chevron-left";
    const nextMailIcon = direction === "rtl" ? "mdi:chevron-left" : "mdi:chevron-right";
    const goBackIcon = prevMailIcon;
    const ScrollWrapper = (param)=>{
        let { children  } = param;
        if (hidden) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    height: "100%",
                    overflowY: "auto",
                    overflowX: "hidden"
                },
                children: children
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                options: {
                    wheelPropagation: false
                },
                children: children
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(sidebar/* default */.Z, {
        hideBackdrop: true,
        direction: "right",
        show: mailDetailsOpen,
        sx: {
            zIndex: 3,
            width: "100%",
            overflow: "hidden"
        },
        onClose: ()=>{
            setMailDetailsOpen(false);
            setShowReplies(false);
        },
        children: mail ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        px: 2.6,
                        py: [
                            2.25,
                            3
                        ],
                        backgroundColor: "background.paper",
                        borderBottom: (theme)=>"1px solid ".concat(theme.palette.divider)
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            alignItems: [
                                "flex-start",
                                "center"
                            ],
                            justifyContent: "space-between"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    overflow: "hidden",
                                    alignItems: "center",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        sx: {
                                            mr: 3,
                                            "& svg": {
                                                color: "text.primary"
                                            }
                                        },
                                        onClick: ()=>{
                                            setMailDetailsOpen(false);
                                            setShowReplies(false);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                            icon: goBackIcon,
                                            fontSize: "1.5rem"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        sx: {
                                            display: "flex",
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            flexDirection: [
                                                "column",
                                                "row"
                                            ]
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                noWrap: true,
                                                sx: {
                                                    mr: 5
                                                },
                                                children: mail.subject
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                sx: {
                                                    display: "flex",
                                                    alignItems: "center"
                                                },
                                                children: mail.labels && mail.labels.length ? mail.labels.map((label)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(chip/* default */.Z, {
                                                        size: "small",
                                                        skin: "light",
                                                        label: label,
                                                        color: labelColors[label],
                                                        sx: {
                                                            height: 20,
                                                            textTransform: "capitalize",
                                                            "&:not(:last-of-type)": {
                                                                mr: 2
                                                            },
                                                            "& .MuiChip-label": {
                                                                fontWeight: 500
                                                            }
                                                        }
                                                    }, label);
                                                }) : null
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    display: "flex"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        size: "small",
                                        disabled: !mail.hasPreviousMail,
                                        sx: {
                                            color: mail.hasPreviousMail ? "text.primary" : "text.secondary"
                                        },
                                        onClick: ()=>dispatch(paginateMail({
                                                dir: "previous",
                                                emailId: mail.id
                                            })),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                            icon: prevMailIcon
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        size: "small",
                                        disabled: !mail.hasNextMail,
                                        sx: {
                                            color: mail.hasNextMail ? "text.primary" : "text.secondary"
                                        },
                                        onClick: ()=>dispatch(paginateMail({
                                                dir: "next",
                                                emailId: mail.id
                                            })),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                            icon: nextMailIcon
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        backgroundColor: "background.paper",
                        p: (theme)=>theme.spacing(3, 2, 3, 3),
                        borderBottom: (theme)=>"1px solid ".concat(theme.palette.divider)
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: [
                                    routeParams && routeParams.folder !== "trash" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        size: "small",
                                        onClick: handleMoveToTrash,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                            icon: "mdi:delete-outline"
                                        })
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        size: "small",
                                        onClick: handleReadMail,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                            icon: "mdi:email-outline",
                                            fontSize: "1.375rem"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(option_menu/* default */.Z, {
                                        leftAlignMenu: true,
                                        options: handleFoldersMenu(),
                                        iconButtonProps: {
                                            size: "small"
                                        },
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                            icon: "mdi:folder-outline",
                                            fontSize: "1.375rem"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(option_menu/* default */.Z, {
                                        leftAlignMenu: true,
                                        options: handleLabelsMenu(),
                                        iconButtonProps: {
                                            size: "small"
                                        },
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                            icon: "mdi:label-outline",
                                            fontSize: "1.375rem"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        size: "small",
                                        onClick: (e)=>handleStarMail(e, mail.id, !mail.isStarred),
                                        sx: {
                                            mr: 1,
                                            ...mail.isStarred ? {
                                                color: "warning.main"
                                            } : {}
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                            icon: "mdi:star-outline"
                                        })
                                    }),
                                    mail.replies.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        size: "small",
                                        onClick: ()=>showReplies ? setShowReplies(false) : setShowReplies(true),
                                        children: showReplies ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                            icon: "mdi:arrow-collapse-vertical",
                                            fontSize: "1.375rem"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                            icon: "mdi:arrow-expand-vertical",
                                            fontSize: "1.375rem"
                                        })
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        size: "small",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                            icon: "mdi:dots-vertical"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        height: "calc(100% - 7.75rem)",
                        backgroundColor: "action.hover"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                py: 4,
                                px: 5,
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "column",
                                justifyContent: "center"
                            },
                            children: [
                                mail.replies.length && !showReplies ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    onClick: ()=>setShowReplies(true),
                                    sx: {
                                        mt: 1,
                                        mb: 5,
                                        color: "text.secondary",
                                        cursor: "pointer"
                                    },
                                    children: [
                                        mail.replies.length,
                                        " Earlier Messages"
                                    ]
                                }) : null,
                                showReplies ? mail.replies.map((reply, index)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        sx: {
                                            mb: 4,
                                            boxShadow: 6,
                                            width: "100%",
                                            borderRadius: 1,
                                            backgroundColor: "background.paper",
                                            border: (theme)=>"1px solid ".concat(theme.palette.divider)
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                sx: {
                                                    p: 5
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    sx: {
                                                        display: "flex",
                                                        flexWrap: "wrap",
                                                        alignItems: "center",
                                                        justifyContent: "space-between"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                            sx: {
                                                                display: "flex",
                                                                alignItems: "center"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                                    alt: reply.from.name,
                                                                    src: reply.from.avatar,
                                                                    sx: {
                                                                        width: "2.375rem",
                                                                        height: "2.375rem",
                                                                        mr: 3
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                                    sx: {
                                                                        display: "flex",
                                                                        flexDirection: "column"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                            sx: {
                                                                                color: "text.secondary"
                                                                            },
                                                                            children: reply.from.name
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                            variant: "body2",
                                                                            sx: {
                                                                                color: "text.disabled"
                                                                            },
                                                                            children: reply.from.email
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                            sx: {
                                                                display: "flex",
                                                                alignItems: "center"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                                    variant: "body2",
                                                                    sx: {
                                                                        mr: 1.75,
                                                                        color: "text.disabled"
                                                                    },
                                                                    children: [
                                                                        new Date(reply.time).toDateString(),
                                                                        " ",
                                                                        new Date(reply.time).toLocaleTimeString("en-US", {
                                                                            hour: "2-digit",
                                                                            minute: "2-digit",
                                                                            hour12: true
                                                                        })
                                                                    ]
                                                                }),
                                                                mail.attachments.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                                    size: "small",
                                                                    sx: {
                                                                        mr: 0.5
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                                        icon: "mdi:attachment",
                                                                        fontSize: 20
                                                                    })
                                                                }) : null,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                                    size: "small",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                                        icon: "mdi:dots-vertical",
                                                                        fontSize: 20
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                                sx: {
                                                    m: "0 !important"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                sx: {
                                                    px: 5,
                                                    py: 0
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    sx: {
                                                        color: "text.secondary"
                                                    },
                                                    dangerouslySetInnerHTML: {
                                                        __html: reply.message
                                                    }
                                                })
                                            }),
                                            reply.attachments.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                                        sx: {
                                                            m: "0 !important"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                        sx: {
                                                            p: 5
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                variant: "body2",
                                                                children: "Attachments"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                                                                children: reply.attachments.map((item)=>{
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, {
                                                                        disableGutters: true,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                    src: item.thumbnail,
                                                                                    alt: item.fileName,
                                                                                    width: "24",
                                                                                    height: "24"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                                children: item.fileName
                                                                            })
                                                                        ]
                                                                    }, item.fileName);
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    }, index);
                                }) : null,
                                mail.replies.length && !showReplies ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HiddenReplyBack, {
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            onClick: ()=>setShowReplies(true)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HiddenReplyFront, {
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            onClick: ()=>setShowReplies(true)
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    sx: {
                                        mb: 4,
                                        width: "100%",
                                        borderRadius: 1,
                                        overflow: "visible",
                                        position: "relative",
                                        backgroundColor: "background.paper",
                                        boxShadow: settings.skin === "bordered" ? 0 : 6,
                                        border: (theme)=>"1px solid ".concat(theme.palette.divider)
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            sx: {
                                                p: 5
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                sx: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    flexWrap: "wrap"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                        sx: {
                                                            display: "flex",
                                                            alignItems: "center"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                                alt: mail.from.name,
                                                                src: mail.from.avatar,
                                                                sx: {
                                                                    width: "2.375rem",
                                                                    height: "2.375rem",
                                                                    mr: 3
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                                sx: {
                                                                    display: "flex",
                                                                    flexDirection: "column"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                        sx: {
                                                                            color: "text.secondary"
                                                                        },
                                                                        children: mail.from.name
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                        variant: "body2",
                                                                        sx: {
                                                                            color: "text.disabled"
                                                                        },
                                                                        children: mail.from.email
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                        sx: {
                                                            display: "flex",
                                                            alignItems: "center"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                                variant: "body2",
                                                                sx: {
                                                                    mr: 1.75,
                                                                    color: "text.disabled"
                                                                },
                                                                children: [
                                                                    new Date(mail.time).toDateString(),
                                                                    " ",
                                                                    new Date(mail.time).toLocaleTimeString("en-US", {
                                                                        hour: "2-digit",
                                                                        minute: "2-digit",
                                                                        hour12: true
                                                                    })
                                                                ]
                                                            }),
                                                            mail.attachments.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                                size: "small",
                                                                sx: {
                                                                    mr: 0.5,
                                                                    color: "action.active"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                                    icon: "mdi:attachment",
                                                                    fontSize: 20
                                                                })
                                                            }) : null,
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(option_menu/* default */.Z, {
                                                                iconButtonProps: {
                                                                    size: "small"
                                                                },
                                                                iconProps: {
                                                                    fontSize: "1.375rem"
                                                                },
                                                                options: [
                                                                    {
                                                                        text: "Reply",
                                                                        menuItemProps: {
                                                                            sx: {
                                                                                "& svg": {
                                                                                    mr: 2
                                                                                }
                                                                            }
                                                                        },
                                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                                            icon: "mdi:share-outline",
                                                                            fontSize: 20
                                                                        })
                                                                    },
                                                                    {
                                                                        text: "Forward",
                                                                        menuItemProps: {
                                                                            sx: {
                                                                                "& svg": {
                                                                                    mr: 2
                                                                                }
                                                                            }
                                                                        },
                                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                                            icon: "mdi:reply-outline",
                                                                            fontSize: 20
                                                                        })
                                                                    }
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                            sx: {
                                                m: "0 !important"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            sx: {
                                                px: 5,
                                                py: 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                sx: {
                                                    color: "text.secondary"
                                                },
                                                dangerouslySetInnerHTML: {
                                                    __html: mail.message
                                                }
                                            })
                                        }),
                                        mail.attachments.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                                    sx: {
                                                        m: "0 !important"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    sx: {
                                                        p: 5
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "body2",
                                                            children: "Attachments"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                                                            children: mail.attachments.map((item)=>{
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, {
                                                                    disableGutters: true,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                src: item.thumbnail,
                                                                                alt: item.fileName,
                                                                                width: "24",
                                                                                height: "24"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                            children: item.fileName
                                                                        })
                                                                    ]
                                                                }, item.fileName);
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: {
                                        p: 5,
                                        width: "100%",
                                        borderRadius: 1,
                                        border: "1px solid",
                                        borderColor: "divider",
                                        backgroundColor: "background.paper",
                                        boxShadow: settings.skin === "bordered" ? 0 : 6
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        sx: {
                                            color: "text.secondary"
                                        },
                                        children: [
                                            "Click here to",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                component: "span",
                                                sx: {
                                                    cursor: "pointer",
                                                    color: "primary.main",
                                                    fontWeight: "inherit"
                                                },
                                                children: "Reply"
                                            }),
                                            " ",
                                            "or",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                component: "span",
                                                sx: {
                                                    cursor: "pointer",
                                                    color: "primary.main",
                                                    fontWeight: "inherit"
                                                },
                                                children: "Forward"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        }) : null
    });
};
/* harmony default export */ var email_MailDetails = (MailDetails);

;// CONCATENATED MODULE: ./src/views/apps/email/MailLog.js
// ** React Imports


// ** MUI Imports














// ** Icon Imports

// ** Third Party Imports

// ** Custom Components Imports

// ** Email App Component Imports


const MailItem = (0,styled/* default */.ZP)(ListItem/* default */.ZP)((param)=>{
    let { theme  } = param;
    return {
        cursor: "pointer",
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        justifyContent: "space-between",
        transition: "border 0.15s ease-in-out, transform 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        "&:not(:first-child)": {
            borderTop: "1px solid ".concat(theme.palette.divider)
        },
        "&:hover": {
            zIndex: 2,
            boxShadow: theme.shadows[3],
            transform: "translateY(-2px)",
            "& .mail-actions": {
                display: "flex"
            },
            "& .mail-info-right": {
                display: "none"
            },
            "& + .MuiListItem-root": {
                borderColor: "transparent"
            }
        },
        [theme.breakpoints.up("xs")]: {
            paddingLeft: theme.spacing(2.5),
            paddingRight: theme.spacing(2.5)
        },
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(5),
            paddingRight: theme.spacing(5)
        }
    };
});
const ScrollWrapper = (param)=>{
    let { children , hidden  } = param;
    if (hidden) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
                height: "100%",
                overflowY: "auto",
                overflowX: "hidden"
            },
            children: children
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
            options: {
                wheelPropagation: false,
                suppressScrollX: true
            },
            children: children
        });
    }
};
const MailLog = (props)=>{
    // ** Props
    const { store , query , hidden , lgAbove , dispatch , setQuery , direction , updateMail , routeParams , labelColors , paginateMail , getCurrentMail , mailDetailsOpen , updateMailLabel , handleSelectMail , setMailDetailsOpen , handleSelectAllMail , handleLeftSidebarToggle  } = props;
    // ** State
    const [refresh, setRefresh] = (0,react.useState)(false);
    // ** Vars
    const folders = [
        {
            name: "draft",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "span",
                sx: {
                    mr: 2,
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    icon: "mdi:pencil-outline",
                    fontSize: 20
                })
            })
        },
        {
            name: "spam",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "span",
                sx: {
                    mr: 2,
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    icon: "mdi:alert-octagon-outline",
                    fontSize: 20
                })
            })
        },
        {
            name: "trash",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "span",
                sx: {
                    mr: 2,
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    icon: "mdi:delete-outline",
                    fontSize: 20
                })
            })
        },
        {
            name: "inbox",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "span",
                sx: {
                    mr: 2,
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    icon: "mdi:email-outline",
                    fontSize: 20
                })
            })
        }
    ];
    const foldersConfig = {
        draft: {
            name: "draft",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "span",
                sx: {
                    mr: 2,
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    icon: "mdi:pencil-outline",
                    fontSize: 20
                })
            })
        },
        spam: {
            name: "spam",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "span",
                sx: {
                    mr: 2,
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    icon: "mdi:alert-octagon-outline",
                    fontSize: 20
                })
            })
        },
        trash: {
            name: "trash",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "span",
                sx: {
                    mr: 2,
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    icon: "mdi:delete-outline",
                    fontSize: 20
                })
            })
        },
        inbox: {
            name: "inbox",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "span",
                sx: {
                    mr: 2,
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    icon: "mdi:email-outline",
                    fontSize: 20
                })
            })
        }
    };
    const foldersObj = {
        inbox: [
            foldersConfig.spam,
            foldersConfig.trash
        ],
        sent: [
            foldersConfig.trash
        ],
        draft: [
            foldersConfig.trash
        ],
        spam: [
            foldersConfig.inbox,
            foldersConfig.trash
        ],
        trash: [
            foldersConfig.inbox,
            foldersConfig.spam
        ]
    };
    const handleMoveToTrash = ()=>{
        dispatch(updateMail({
            emailIds: store.selectedMails,
            dataToUpdate: {
                folder: "trash"
            }
        }));
        dispatch(handleSelectAllMail(false));
    };
    const handleStarMail = (e, id, value)=>{
        e.stopPropagation();
        dispatch(updateMail({
            emailIds: [
                id
            ],
            dataToUpdate: {
                isStarred: value
            }
        }));
    };
    const handleReadMail = (id, value)=>{
        const arr = Array.isArray(id) ? [
            ...id
        ] : [
            id
        ];
        dispatch(updateMail({
            emailIds: arr,
            dataToUpdate: {
                isRead: value
            }
        }));
        dispatch(handleSelectAllMail(false));
    };
    const handleLabelUpdate = (id, label)=>{
        const arr = Array.isArray(id) ? [
            ...id
        ] : [
            id
        ];
        dispatch(updateMailLabel({
            emailIds: arr,
            label
        }));
    };
    const handleFolderUpdate = (id, folder)=>{
        const arr = Array.isArray(id) ? [
            ...id
        ] : [
            id
        ];
        dispatch(updateMail({
            emailIds: arr,
            dataToUpdate: {
                folder
            }
        }));
    };
    const handleRefreshMailsClick = ()=>{
        setRefresh(true);
        (0,main.setTimeout)(()=>setRefresh(false), 1000);
    };
    const handleLabelsMenu = ()=>{
        const array = [];
        Object.entries(labelColors).map((param)=>{
            let [key, value] = param;
            array.push({
                text: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    sx: {
                        textTransform: "capitalize"
                    },
                    children: key
                }),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    component: "span",
                    sx: {
                        mr: 2,
                        color: "".concat(value, ".main")
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                        icon: "mdi:circle",
                        fontSize: "0.75rem"
                    })
                }),
                menuItemProps: {
                    onClick: ()=>{
                        handleLabelUpdate(store.selectedMails, key);
                        dispatch(handleSelectAllMail(false));
                    }
                }
            });
        });
        return array;
    };
    const handleFoldersMenu = ()=>{
        const array = [];
        if (routeParams && routeParams.folder && !routeParams.label && foldersObj[routeParams.folder]) {
            foldersObj[routeParams.folder].map((folder)=>{
                array.length = 0;
                array.push({
                    icon: folder.icon,
                    text: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            textTransform: "capitalize"
                        },
                        children: folder.name
                    }),
                    menuItemProps: {
                        onClick: ()=>{
                            handleFolderUpdate(store.selectedMails, folder.name);
                            dispatch(handleSelectAllMail(false));
                        }
                    }
                });
            });
        } else if (routeParams && routeParams.label) {
            folders.map((folder)=>{
                array.length = 0;
                array.push({
                    icon: folder.icon,
                    text: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            textTransform: "capitalize"
                        },
                        children: folder.name
                    }),
                    menuItemProps: {
                        onClick: ()=>{
                            handleFolderUpdate(store.selectedMails, folder.name);
                            dispatch(handleSelectAllMail(false));
                        }
                    }
                });
            });
        } else {
            foldersObj["inbox"].map((folder)=>{
                array.length = 0;
                array.push({
                    icon: folder.icon,
                    text: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            textTransform: "capitalize"
                        },
                        children: folder.name
                    }),
                    menuItemProps: {
                        onClick: ()=>{
                            handleFolderUpdate(store.selectedMails, folder.name);
                            dispatch(handleSelectAllMail(false));
                        }
                    }
                });
            });
        }
        return array;
    };
    const renderMailLabels = (arr)=>{
        return arr.map((label, index)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "span",
                sx: {
                    mr: 3.5,
                    color: "".concat(labelColors[label], ".main")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    icon: "mdi:circle",
                    fontSize: "0.625rem"
                })
            }, index);
        });
    };
    const mailDetailsProps = {
        hidden,
        folders,
        dispatch,
        direction,
        foldersObj,
        updateMail,
        routeParams,
        labelColors,
        paginateMail,
        handleStarMail,
        mailDetailsOpen,
        handleLabelUpdate,
        handleFolderUpdate,
        setMailDetailsOpen,
        mail: store && store.currentMail ? store.currentMail : null
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            width: "100%",
            overflow: "hidden",
            position: "relative",
            "& .ps__rail-y": {
                zIndex: 5
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    height: "100%",
                    backgroundColor: "background.paper"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            px: 5,
                            py: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                alignItems: "center",
                                width: "100%"
                            },
                            children: [
                                lgAbove ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    onClick: handleLeftSidebarToggle,
                                    sx: {
                                        mr: 1,
                                        ml: -2
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                        icon: "mdi:menu",
                                        fontSize: 20
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    value: query,
                                    placeholder: "Search mail",
                                    onChange: (e)=>setQuery(e.target.value),
                                    sx: {
                                        width: "100%",
                                        "&:before, &:after": {
                                            display: "none"
                                        }
                                    },
                                    startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                        position: "start",
                                        sx: {
                                            color: "text.disabled"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                            icon: "mdi:magnify",
                                            fontSize: "1.375rem"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        sx: {
                            m: "0 !important"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        sx: {
                            m: "0 !important"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            p: 0,
                            position: "relative",
                            overflowX: "hidden",
                            height: "calc(100% - 7rem)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollWrapper, {
                                hidden: hidden,
                                children: store && store.mails && store.mails.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                                    sx: {
                                        p: 0
                                    },
                                    children: store.mails.map((mail)=>{
                                        const mailReadToggleIcon = mail.isRead ? "mdi:email-outline" : "mdi:email-open-outline";
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MailItem, {
                                            sx: {
                                                backgroundColor: mail.isRead ? "action.hover" : "background.paper"
                                            },
                                            onClick: ()=>{
                                                setMailDetailsOpen(true);
                                                dispatch(getCurrentMail(mail.id));
                                                dispatch(updateMail({
                                                    emailIds: [
                                                        mail.id
                                                    ],
                                                    dataToUpdate: {
                                                        isRead: true
                                                    }
                                                }));
                                                (0,main.setTimeout)(()=>{
                                                    dispatch(handleSelectAllMail(false));
                                                }, 600);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    sx: {
                                                        mr: 4,
                                                        display: "flex",
                                                        overflow: "hidden",
                                                        alignItems: "center"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                            alt: mail.from.name,
                                                            src: mail.from.avatar,
                                                            sx: {
                                                                mr: 3,
                                                                width: "2rem",
                                                                height: "2rem"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                            sx: {
                                                                display: "flex",
                                                                overflow: "hidden",
                                                                flexDirection: {
                                                                    xs: "column",
                                                                    sm: "row"
                                                                },
                                                                alignItems: {
                                                                    xs: "flex-start",
                                                                    sm: "center"
                                                                }
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    sx: {
                                                                        mr: 4,
                                                                        fontWeight: 500,
                                                                        whiteSpace: "nowrap",
                                                                        width: [
                                                                            "100%",
                                                                            "auto"
                                                                        ],
                                                                        overflow: [
                                                                            "hidden",
                                                                            "unset"
                                                                        ],
                                                                        textOverflow: [
                                                                            "ellipsis",
                                                                            "unset"
                                                                        ]
                                                                    },
                                                                    children: mail.from.name
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    noWrap: true,
                                                                    variant: "body2",
                                                                    sx: {
                                                                        width: "100%"
                                                                    },
                                                                    children: mail.subject
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    className: "mail-actions",
                                                    sx: {
                                                        display: "none",
                                                        alignItems: "center",
                                                        justifyContent: "flex-end"
                                                    },
                                                    children: [
                                                        routeParams && routeParams.folder !== "trash" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                            placement: "top",
                                                            title: "Delete Mail",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                                onClick: (e)=>{
                                                                    e.stopPropagation();
                                                                    dispatch(updateMail({
                                                                        emailIds: [
                                                                            mail.id
                                                                        ],
                                                                        dataToUpdate: {
                                                                            folder: "trash"
                                                                        }
                                                                    }));
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                                    icon: "mdi:delete-outline"
                                                                })
                                                            })
                                                        }) : null,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                            placement: "top",
                                                            title: mail.isRead ? "Unread Mail" : "Read Mail",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                                onClick: (e)=>{
                                                                    e.stopPropagation();
                                                                    handleReadMail([
                                                                        mail.id
                                                                    ], !mail.isRead);
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                                    icon: mailReadToggleIcon
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                            placement: "top",
                                                            title: "Move to Spam",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                                onClick: (e)=>{
                                                                    e.stopPropagation();
                                                                    handleFolderUpdate([
                                                                        mail.id
                                                                    ], "spam");
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                                    icon: "mdi:alert-octagon-outline"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    className: "mail-info-right",
                                                    sx: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "flex-end"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "caption",
                                                        sx: {
                                                            minWidth: "50px",
                                                            textAlign: "right",
                                                            whiteSpace: "nowrap",
                                                            color: "text.disabled"
                                                        },
                                                        children: new Date(mail.time).toLocaleTimeString("en-US", {
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                            hour12: true
                                                        })
                                                    })
                                                })
                                            ]
                                        }, mail.id);
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    sx: {
                                        mt: 6,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        "& svg": {
                                            mr: 2
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                            icon: "mdi:alert-circle-outline",
                                            fontSize: 20
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            children: "No Mails Found"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Backdrop/* default */.Z, {
                                open: refresh,
                                onClick: ()=>setRefresh(false),
                                sx: {
                                    zIndex: 5,
                                    position: "absolute",
                                    color: "common.white",
                                    backgroundColor: "action.disabledBackground"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                    color: "inherit"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(email_MailDetails, {
                ...mailDetailsProps
            })
        ]
    });
};
/* harmony default export */ var email_MailLog = (MailLog);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 2 modules
var Drawer = __webpack_require__(77533);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(59334);
// EXTERNAL MODULE: ./node_modules/@mui/material/Badge/Badge.js + 2 modules
var Badge = __webpack_require__(19529);
// EXTERNAL MODULE: ./src/@core/hooks/useBgColor.js
var useBgColor = __webpack_require__(19550);
;// CONCATENATED MODULE: ./src/@core/components/mui/badge/index.js
// ** MUI Imports


// ** Hooks Imports

const badge_Badge = (props)=>{
    // ** Props
    const { sx , skin , color  } = props;
    // ** Hook
    const bgColors = (0,useBgColor/* default */.Z)();
    const colors = {
        primary: {
            ...bgColors.primaryLight
        },
        secondary: {
            ...bgColors.secondaryLight
        },
        success: {
            ...bgColors.successLight
        },
        error: {
            ...bgColors.errorLight
        },
        warning: {
            ...bgColors.warningLight
        },
        info: {
            ...bgColors.infoLight
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
        ...props,
        sx: skin === "light" && color ? Object.assign({
            "& .MuiBadge-badge": colors[color]
        }, sx) : sx
    });
};
/* harmony default export */ var badge = (badge_Badge);

;// CONCATENATED MODULE: ./src/views/apps/email/SidebarLeft.js
// ** Next Import


// ** MUI Imports









// ** Icon Imports

// ** Third Party Imports

// ** Custom Components Imports

// ** Styled Components
const ListItemStyled = (0,styled/* default */.ZP)(ListItem/* default */.ZP)((param)=>{
    let { theme  } = param;
    return {
        borderLeftWidth: "3px",
        borderLeftStyle: "solid",
        padding: theme.spacing(0, 5),
        marginBottom: theme.spacing(2)
    };
});
const ListBadge = (0,styled/* default */.ZP)(badge)(()=>({
        "& .MuiBadge-badge": {
            height: "18px",
            minWidth: "18px",
            transform: "none",
            position: "relative",
            transformOrigin: "none"
        }
    }));
const SidebarLeft = (props)=>{
    // ** Props
    const { store , hidden , lgAbove , dispatch , leftSidebarOpen , leftSidebarWidth , setMailDetailsOpen , handleSelectAllMail , handleLeftSidebarToggle  } = props;
    const RenderBadge = (folder, color)=>{
        if (store && store.mailMeta && store.mailMeta[folder] > 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListBadge, {
                skin: "light",
                color: color,
                sx: {
                    ml: 2
                },
                badgeContent: store.mailMeta[folder]
            });
        } else {
            return null;
        }
    };
    const handleActiveItem = (type, value)=>{
        if (store && store.filter[type] !== value) {
            return false;
        } else {
            return true;
        }
    };
    const handleListItemClick = ()=>{
        setMailDetailsOpen(false);
        setTimeout(()=>dispatch(handleSelectAllMail(false)), 50);
        handleLeftSidebarToggle();
    };
    const activeInboxCondition = store && handleActiveItem("folder", "inbox") && store.filter.folder === "inbox" && store.filter.label === "";
    const ScrollWrapper = (param)=>{
        let { children  } = param;
        if (hidden) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    height: "100%",
                    overflowY: "auto",
                    overflowX: "hidden"
                },
                children: children
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                options: {
                    wheelPropagation: false
                },
                children: children
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
        open: leftSidebarOpen,
        onClose: handleLeftSidebarToggle,
        variant: lgAbove ? "permanent" : "temporary",
        ModalProps: {
            disablePortal: true,
            keepMounted: true // Better open performance on mobile.
        },
        sx: {
            zIndex: 9,
            display: "block",
            position: lgAbove ? "static" : "absolute",
            "& .MuiDrawer-paper": {
                boxShadow: "none",
                width: leftSidebarWidth,
                zIndex: lgAbove ? 2 : "drawer",
                position: lgAbove ? "static" : "absolute"
            },
            "& .MuiBackdrop-root": {
                position: "absolute"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    pt: 1.25,
                    overflowY: "hidden"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* default */.Z, {
                    component: "div",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemStyled, {
                            component: (link_default()),
                            href: "/apps/email/inbox",
                            onClick: handleListItemClick,
                            sx: {
                                pt: 0.5,
                                borderLeftColor: (theme)=>activeInboxCondition ? theme.palette.primary.main : "transparent"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    sx: {
                                        color: activeInboxCondition ? "primary.main" : "text.secondary"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                        icon: "mdi:email-outline",
                                        fontSize: 20
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: "Inbox",
                                    primaryTypographyProps: {
                                        noWrap: true,
                                        sx: {
                                            ...activeInboxCondition && {
                                                color: "primary.main"
                                            }
                                        }
                                    }
                                }),
                                RenderBadge("inbox", "primary")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemStyled, {
                            component: (link_default()),
                            href: "/apps/email/sent",
                            onClick: handleListItemClick,
                            sx: {
                                borderLeftColor: handleActiveItem("folder", "sent") ? "primary.main" : "transparent"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    sx: {
                                        color: handleActiveItem("folder", "sent") ? "primary.main" : "text.secondary"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                        icon: "mdi:send-outline",
                                        fontSize: 20
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: "Sent",
                                    primaryTypographyProps: {
                                        noWrap: true,
                                        sx: {
                                            ...handleActiveItem("folder", "sent") && {
                                                color: "primary.main"
                                            }
                                        }
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemStyled, {
                            component: (link_default()),
                            href: "/apps/email/draft",
                            onClick: handleListItemClick,
                            sx: {
                                borderLeftColor: handleActiveItem("folder", "draft") ? "primary.main" : "transparent"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    sx: {
                                        color: handleActiveItem("folder", "draft") ? "primary.main" : "text.secondary"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                        icon: "mdi:pencil-outline",
                                        fontSize: 20
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: "Draft",
                                    primaryTypographyProps: {
                                        noWrap: true,
                                        sx: {
                                            ...handleActiveItem("folder", "draft") && {
                                                color: "primary.main"
                                            }
                                        }
                                    }
                                }),
                                RenderBadge("draft", "warning")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemStyled, {
                            component: (link_default()),
                            href: "/apps/email/starred",
                            onClick: handleListItemClick,
                            sx: {
                                borderLeftColor: handleActiveItem("folder", "starred") ? "primary.main" : "transparent"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    sx: {
                                        color: handleActiveItem("folder", "starred") ? "primary.main" : "text.secondary"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                        icon: "mdi:star-outline",
                                        fontSize: 20
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: "Starred",
                                    primaryTypographyProps: {
                                        noWrap: true,
                                        sx: {
                                            ...handleActiveItem("folder", "starred") && {
                                                color: "primary.main"
                                            }
                                        }
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemStyled, {
                            component: (link_default()),
                            href: "/apps/email/spam",
                            onClick: handleListItemClick,
                            sx: {
                                borderLeftColor: handleActiveItem("folder", "spam") ? "primary.main" : "transparent"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    sx: {
                                        color: handleActiveItem("folder", "spam") ? "primary.main" : "text.secondary"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                        icon: "mdi:alert-octagon-outline",
                                        fontSize: 20
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: "Spam",
                                    primaryTypographyProps: {
                                        noWrap: true,
                                        sx: {
                                            ...handleActiveItem("folder", "spam") && {
                                                color: "primary.main"
                                            }
                                        }
                                    }
                                }),
                                RenderBadge("spam", "error")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemStyled, {
                            component: (link_default()),
                            href: "/apps/email/trash",
                            onClick: handleListItemClick,
                            sx: {
                                borderLeftColor: handleActiveItem("folder", "trash") ? "primary.main" : "transparent"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    sx: {
                                        color: handleActiveItem("folder", "trash") ? "primary.main" : "text.secondary"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                        icon: "mdi:delete-outline",
                                        fontSize: 20
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: "Trash",
                                    primaryTypographyProps: {
                                        noWrap: true,
                                        sx: {
                                            ...handleActiveItem("folder", "trash") && {
                                                color: "primary.main"
                                            }
                                        }
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var email_SidebarLeft = (SidebarLeft);

// EXTERNAL MODULE: ./node_modules/@mui/material/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(87918);
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js + 5 modules
var Menu = __webpack_require__(35294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(11057);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(18972);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 13 modules
var TextField = __webpack_require__(2202);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputLabel/InputLabel.js + 3 modules
var InputLabel = __webpack_require__(33841);
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonGroup/ButtonGroup.js + 2 modules
var ButtonGroup = __webpack_require__(68540);
// EXTERNAL MODULE: ./node_modules/@mui/material/useAutocomplete/useAutocomplete.js
var useAutocomplete = __webpack_require__(12957);
// EXTERNAL MODULE: ./node_modules/@mui/material/Autocomplete/Autocomplete.js + 1 modules
var Autocomplete = __webpack_require__(5306);
// EXTERNAL MODULE: ./node_modules/draft-js/lib/Draft.js
var Draft = __webpack_require__(9041);
// EXTERNAL MODULE: ./src/@core/components/mui/avatar/index.js
var avatar = __webpack_require__(92024);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/@core/components/react-draft-wysiwyg/index.js
// ** Next Import

// ! To avoid 'Window is not defined' error
const ReactDraftWysiwyg = dynamic_default()(()=>__webpack_require__.e(/* import() */ 6925).then(__webpack_require__.t.bind(__webpack_require__, 35108, 23)).then((mod)=>mod.Editor), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(35108)
            ]
    },
    ssr: false
});
/* harmony default export */ var react_draft_wysiwyg = (ReactDraftWysiwyg);

;// CONCATENATED MODULE: ./src/@core/styles/libs/react-draft-wysiwyg/index.js
// ** MUI imports

const EditorWrapper = (0,styled/* default */.ZP)("div")((param)=>{
    let { theme  } = param;
    return {
        "& .rdw-editor-wrapper": {
            border: "1px solid ".concat(theme.palette.divider),
            "& .rdw-editor-toolbar": {
                border: 0,
                marginBottom: 0,
                background: theme.palette.background.paper,
                borderBottom: "1px solid ".concat(theme.palette.divider),
                "& .rdw-fontsize-dropdown": {
                    minWidth: 50
                },
                "& .rdw-link-modal": {
                    height: "auto"
                },
                "& .rdw-colorpicker-modal, & .rdw-link-modal, & .rdw-embedded-modal, & .rdw-emoji-modal, & .rdw-image-modal": {
                    boxShadow: theme.shadows[8],
                    borderColor: theme.palette.divider,
                    backgroundColor: theme.palette.background.paper
                },
                "& .rdw-dropdown-optionwrapper": {
                    boxShadow: theme.shadows[8],
                    borderColor: theme.palette.divider,
                    backgroundColor: theme.palette.background.paper,
                    "& .rdw-dropdownoption-highlighted": {
                        backgroundColor: theme.palette.action.hover
                    },
                    "& .rdw-dropdownoption-active": {
                        backgroundColor: theme.palette.action.selected
                    }
                },
                "& .rdw-option-wrapper, & .rdw-dropdown-wrapper": {
                    borderColor: theme.palette.divider,
                    background: theme.palette.background.paper,
                    "& .rdw-dropdown-carettoopen": {
                        left: "auto",
                        right: "10%",
                        borderTopColor: theme.palette.text.disabled
                    },
                    "& .rdw-dropdown-carettoclose": {
                        left: "auto",
                        right: "10%",
                        borderBottomColor: theme.palette.text.disabled
                    },
                    ...theme.palette.mode === "dark" ? {
                        "& img": {
                            filter: "invert(1)"
                        }
                    } : {}
                },
                "& .rdw-embedded-modal-size-input, & .rdw-image-modal-size-input": {
                    width: "60%",
                    minHeight: 30
                },
                "& .rdw-link-modal-input, & .rdw-embedded-modal-link-input, & .rdw-image-modal-url-input": {
                    minHeight: 38
                },
                "& .rdw-link-modal-input, & .rdw-embedded-modal-link-input, & .rdw-image-modal-url-input, & .rdw-embedded-modal-size-input, & .rdw-image-modal-size-input": {
                    fontSize: "1rem",
                    background: "none",
                    padding: theme.spacing(0, 3.5),
                    color: theme.palette.text.primary,
                    borderColor: theme.palette.divider,
                    borderRadius: theme.shape.borderRadius,
                    "&:focus": {
                        borderColor: theme.palette.primary.main
                    },
                    "&::placeholder, &:-ms-input-placeholder, &::-ms-input-placeholder": {
                        color: theme.palette.text.disabled
                    }
                },
                "& .rdw-link-modal-btn, & .rdw-embedded-modal-btn, & .rdw-image-modal-btn": {
                    border: 0,
                    lineHeight: 1.71,
                    borderRadius: "5px",
                    letterSpacing: "0.3px",
                    textTransform: "uppercase",
                    fontWeight: theme.typography.fontWeightMedium,
                    "&:first-of-type:not([disabled])": {
                        boxShadow: theme.shadows[3],
                        color: theme.palette.primary.contrastText,
                        backgroundColor: theme.palette.primary.main,
                        "&:hover": {
                            boxShadow: theme.shadows[4],
                            backgroundColor: theme.palette.primary.dark
                        },
                        "&:active": {
                            boxShadow: theme.shadows[3]
                        }
                    },
                    "&:last-child": {
                        boxShadow: theme.shadows[3],
                        color: theme.palette.secondary.contrastText,
                        backgroundColor: theme.palette.secondary.main,
                        "&:hover": {
                            boxShadow: theme.shadows[4],
                            backgroundColor: theme.palette.secondary.dark
                        },
                        "&:active": {
                            boxShadow: theme.shadows[3]
                        }
                    },
                    "&[disabled]": {
                        cursor: "default",
                        boxShadow: "none",
                        color: theme.palette.text.disabled,
                        backgroundColor: theme.palette.action.disabledBackground
                    }
                }
            },
            "& .rdw-editor-main": {
                cursor: "text",
                padding: "0 1rem",
                minHeight: "10rem",
                color: theme.palette.text.primary,
                ...theme.direction === "rtl" ? {
                    "& .public-DraftStyleDefault-block": {
                        direction: "ltr !important",
                        textAlign: "left !important"
                    }
                } : {}
            }
        }
    };
});
const ToolbarBottom = (0,styled/* default */.ZP)("div")(()=>({
        "& .rdw-editor-wrapper": {
            display: "flex",
            flexDirection: "column-reverse"
        }
    }));
const Borderless = (0,styled/* default */.ZP)("div")(()=>({
        "& .rdw-editor-wrapper, & .rdw-editor-toolbar": {
            border: "0 !important"
        }
    }));

// EXTERNAL MODULE: ./src/@core/utils/get-initials.js
var get_initials = __webpack_require__(83552);
// EXTERNAL MODULE: ./node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css
var dist_react_draft_wysiwyg = __webpack_require__(49552);
;// CONCATENATED MODULE: ./src/views/apps/email/ComposePopup.js
// ** React Imports


// ** MUI Imports















// ** Icon Imports

// ** Third Party Components

// ** Custom Components Imports



// ** Styled Component Imports

// ** Utils Import

// ** Styles

const menuItemsArr = [
    {
        name: "Ross Geller",
        value: "ross",
        src: "/images/avatars/1.png"
    },
    {
        name: "Pheobe Buffay",
        value: "pheobe",
        src: "/images/avatars/2.png"
    },
    {
        name: "Joey Tribbiani",
        value: "joey",
        src: "/images/avatars/3.png"
    },
    {
        name: "Rachel Green",
        value: "rachel",
        src: "/images/avatars/4.png"
    },
    {
        name: "Chandler Bing",
        value: "chandler",
        src: "/images/avatars/5.png"
    },
    {
        name: "Monica Geller",
        value: "monica",
        src: "/images/avatars/8.png"
    }
];
const filter = (0,useAutocomplete/* createFilterOptions */.D)();
const ComposePopup = (props)=>{
    // ** Props
    const { mdAbove , composeOpen , composePopupWidth , toggleComposeOpen  } = props;
    // ** States
    const [emailTo, setEmailTo] = (0,react.useState)([]);
    const [ccValue, setccValue] = (0,react.useState)([]);
    const [subjectValue, setSubjectValue] = (0,react.useState)("");
    const [bccValue, setbccValue] = (0,react.useState)([]);
    const [sendBtnOpen, setSendBtnOpen] = (0,react.useState)(false);
    const [messageValue, setMessageValue] = (0,react.useState)(Draft.EditorState.createEmpty());
    const [visibility, setVisibility] = (0,react.useState)({
        cc: false,
        bcc: false
    });
    // ** Ref
    const anchorRefSendBtn = (0,react.useRef)(null);
    const toggleVisibility = (value)=>setVisibility({
            ...visibility,
            [value]: !visibility[value]
        });
    const handleSendMenuItemClick = ()=>{
        setSendBtnOpen(false);
    };
    const handleSendBtnToggle = ()=>{
        setSendBtnOpen((prevOpen)=>!prevOpen);
    };
    const handleMailDelete = (value, state, setState)=>{
        const arr = state;
        const index = arr.findIndex((i)=>i.value === value);
        arr.splice(index, 1);
        setState([
            ...arr
        ]);
    };
    const handlePopupClose = ()=>{
        toggleComposeOpen();
        setEmailTo([]);
        setccValue([]);
        setbccValue([]);
        setSubjectValue("");
        setMessageValue(Draft.EditorState.createEmpty());
        setVisibility({
            cc: false,
            bcc: false
        });
    };
    const handleMinimize = ()=>{
        toggleComposeOpen();
        setEmailTo(emailTo);
        setccValue(ccValue);
        setbccValue(bccValue);
        setVisibility(visibility);
        setMessageValue(messageValue);
        setSubjectValue(subjectValue);
    };
    const renderCustomChips = (array, getTagProps, state, setState)=>{
        return array.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                size: "small",
                label: item.name,
                ...getTagProps({
                    index
                }),
                deleteIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    icon: "mdi:close"
                }),
                onDelete: ()=>handleMailDelete(item.value, state, setState)
            }, item.value));
    };
    const renderListItem = (props, option, array, setState)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
            sx: {
                cursor: "pointer"
            },
            onClick: ()=>setState([
                    ...array,
                    option
                ]),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    option.src.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.Z, {
                        src: option.src,
                        alt: option.name,
                        sx: {
                            mr: 3,
                            width: 22,
                            height: 22
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.Z, {
                        skin: "light",
                        color: "primary",
                        sx: {
                            mr: 3,
                            width: 22,
                            height: 22,
                            fontSize: ".75rem"
                        },
                        children: (0,get_initials/* getInitials */.Q)(option.name)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            fontSize: "0.875rem"
                        },
                        children: option.name
                    })
                ]
            })
        }, option.value);
    };
    const addNewOption = (options, params)=>{
        const filtered = filter(options, params);
        const { inputValue  } = params;
        const isExisting = options.some((option)=>inputValue === option.name);
        if (inputValue !== "" && !isExisting) {
            filtered.push({
                name: inputValue,
                value: inputValue,
                src: ""
            });
        }
        // @ts-ignore
        return filtered;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
        hideBackdrop: true,
        anchor: "bottom",
        open: composeOpen,
        variant: "temporary",
        onClose: toggleComposeOpen,
        sx: {
            top: "auto",
            left: "auto",
            right: mdAbove ? "1.5rem" : "1rem",
            bottom: "1.5rem",
            display: "block",
            zIndex: (theme)=>"".concat(theme.zIndex.drawer, " + 1"),
            "& .MuiDrawer-paper": {
                borderRadius: 1,
                position: "static",
                width: composePopupWidth
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    px: 4,
                    py: 2.5,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    backgroundColor: (theme)=>"rgba(".concat(theme.palette.customColors.main, ", 0.08)")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            fontWeight: 600,
                            color: "text.secondary"
                        },
                        children: "Compose Mail"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                sx: {
                                    p: 1,
                                    mr: 2,
                                    color: "action.active"
                                },
                                onClick: handleMinimize,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                    icon: "mdi:minus",
                                    fontSize: 20
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                sx: {
                                    p: 1,
                                    color: "action.active"
                                },
                                onClick: handlePopupClose,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                    icon: "mdi:close",
                                    fontSize: 20
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    py: 1,
                    px: 4,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: (theme)=>"1px solid ".concat(theme.palette.divider)
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            width: "100%",
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                                    sx: {
                                        mr: 3,
                                        color: "text.disabled"
                                    },
                                    htmlFor: "email-to-select",
                                    children: "To:"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
                                multiple: true,
                                freeSolo: true,
                                value: emailTo,
                                clearIcon: false,
                                id: "email-to-select",
                                filterSelectedOptions: true,
                                options: menuItemsArr,
                                ListboxComponent: List/* default */.Z,
                                filterOptions: addNewOption,
                                getOptionLabel: (option)=>option.name,
                                renderOption: (props, option)=>renderListItem(props, option, emailTo, setEmailTo),
                                renderTags: (array, getTagProps)=>renderCustomChips(array, getTagProps, emailTo, setEmailTo),
                                sx: {
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        p: 2
                                    },
                                    "& .MuiAutocomplete-endAdornment": {
                                        display: "none"
                                    }
                                },
                                renderInput: (params)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                        ...params,
                                        autoComplete: "new-password",
                                        sx: {
                                            border: 0,
                                            "& fieldset": {
                                                border: "0 !important"
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                p: "0 !important"
                                            }
                                        }
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        sx: {
                            color: "text.secondary"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                component: "span",
                                sx: {
                                    cursor: "pointer"
                                },
                                onClick: ()=>toggleVisibility("cc"),
                                children: "Cc"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                component: "span",
                                sx: {
                                    mx: 2
                                },
                                children: "|"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                component: "span",
                                sx: {
                                    cursor: "pointer"
                                },
                                onClick: ()=>toggleVisibility("bcc"),
                                children: "Bcc"
                            })
                        ]
                    })
                ]
            }),
            visibility.cc ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    py: 1,
                    px: 4,
                    display: "flex",
                    alignItems: "center",
                    borderBottom: (theme)=>"1px solid ".concat(theme.palette.divider)
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                            sx: {
                                mr: 3,
                                color: "text.disabled"
                            },
                            htmlFor: "email-cc-select",
                            children: "Cc:"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        fullWidth: true,
                        size: "small",
                        sx: {
                            border: 0,
                            "& fieldset": {
                                border: "0 !important"
                            },
                            "& .MuiOutlinedInput-root": {
                                p: "0 !important"
                            }
                        }
                    })
                ]
            }) : null,
            visibility.bcc ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    py: 1,
                    px: 4,
                    display: "flex",
                    alignItems: "center",
                    borderBottom: (theme)=>"1px solid ".concat(theme.palette.divider)
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                            sx: {
                                mr: 3,
                                color: "text.disabled"
                            },
                            htmlFor: "email-bcc-select",
                            children: "Bcc:"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        fullWidth: true,
                        size: "small",
                        sx: {
                            border: 0,
                            "& fieldset": {
                                border: "0 !important"
                            },
                            "& .MuiOutlinedInput-root": {
                                p: "0 !important"
                            }
                        }
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    py: 1,
                    px: 4,
                    display: "flex",
                    alignItems: "center",
                    borderBottom: (theme)=>"1px solid ".concat(theme.palette.divider)
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                            sx: {
                                mr: 3,
                                color: "text.disabled"
                            },
                            htmlFor: "email-subject-input",
                            children: "Subject:"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        fullWidth: true,
                        value: subjectValue,
                        id: "email-subject-input",
                        onChange: (e)=>setSubjectValue(e.target.value),
                        sx: {
                            "&:before, &:after": {
                                display: "none"
                            },
                            "& .MuiInput-input": {
                                py: 1.875
                            }
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorWrapper, {
                sx: {
                    "& .rdw-editor-wrapper": {
                        border: "0 !important"
                    },
                    "& .rdw-editor-toolbar": {
                        p: "0.35rem 1rem !important",
                        "& .rdw-option-wrapper": {
                            minWidth: "1.25rem",
                            borderRadius: "4px !important"
                        },
                        "& .rdw-inline-wrapper, & .rdw-text-align-wrapper": {
                            mb: 0
                        }
                    },
                    "& .rdw-editor-main": {
                        px: "1.25rem"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_draft_wysiwyg, {
                    editorState: messageValue,
                    onEditorStateChange: (editorState)=>setMessageValue(editorState),
                    placeholder: "Message",
                    toolbar: {
                        options: [
                            "inline",
                            "textAlign"
                        ],
                        inline: {
                            inDropdown: false,
                            options: [
                                "bold",
                                "italic",
                                "underline",
                                "strikethrough"
                            ]
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    px: 4,
                    py: 3.5,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderTop: (theme)=>"1px solid ".concat(theme.palette.divider)
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonGroup/* default */.Z, {
                                variant: "contained",
                                ref: anchorRefSendBtn,
                                "aria-label": "split button",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        onClick: handlePopupClose,
                                        children: "Send"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        size: "small",
                                        "aria-haspopup": "true",
                                        onClick: handleSendBtnToggle,
                                        "aria-label": "select merge strategy",
                                        "aria-expanded": sendBtnOpen ? "true" : undefined,
                                        "aria-controls": sendBtnOpen ? "email-send-menu" : undefined,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                            icon: "mdi:chevron-up",
                                            fontSize: "1.25rem"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* default */.Z, {
                                keepMounted: true,
                                open: sendBtnOpen,
                                id: "email-send-menu",
                                onClose: handleSendMenuItemClick,
                                anchorEl: anchorRefSendBtn.current,
                                anchorOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                        onClick: handleSendMenuItemClick,
                                        children: "Schedule Send"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                        onClick: handleSendMenuItemClick,
                                        children: "Save as Draft"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                size: "small",
                                sx: {
                                    ml: 3.5
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                    icon: "mdi:attachment",
                                    fontSize: "1.25rem"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(option_menu/* default */.Z, {
                                iconButtonProps: {
                                    size: "small"
                                },
                                iconProps: {
                                    fontSize: "1.25rem"
                                },
                                options: [
                                    "Print",
                                    "Check spelling",
                                    "Plain text mode"
                                ],
                                menuProps: {
                                    anchorOrigin: {
                                        vertical: "top",
                                        horizontal: "right"
                                    },
                                    transformOrigin: {
                                        vertical: "bottom",
                                        horizontal: "right"
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                size: "small",
                                onClick: handlePopupClose,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                    icon: "mdi:delete-outline",
                                    fontSize: "1.25rem"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var email_ComposePopup = (ComposePopup);

// EXTERNAL MODULE: ./src/store/apps/email/index.js
var email = __webpack_require__(94559);
;// CONCATENATED MODULE: ./src/views/apps/email/Email.js
// ** React Imports


// ** Redux Imports

// ** MUI Imports



// ** Hooks

// ** Email App Component Imports



// ** Actions

// ** Variables
const labelColors = {
    private: "error",
    personal: "success",
    company: "primary",
    important: "warning"
};
const EmailAppLayout = (param)=>{
    let { folder , label  } = param;
    // ** States
    const [query, setQuery] = (0,react.useState)("");
    const [composeOpen, setComposeOpen] = (0,react.useState)(false);
    const [mailDetailsOpen, setMailDetailsOpen] = (0,react.useState)(false);
    const [leftSidebarOpen, setLeftSidebarOpen] = (0,react.useState)(false);
    // ** Hooks
    const theme = (0,useTheme/* default */.Z)();
    const { settings  } = (0,useSettings/* useSettings */.r)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const lgAbove = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("lg"));
    const mdAbove = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("md"));
    const smAbove = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("sm"));
    const hidden = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("lg"));
    const store = (0,es/* useSelector */.v9)((state)=>state.email);
    // ** Vars
    const leftSidebarWidth = 260;
    const { skin , direction  } = settings;
    const composePopupWidth = mdAbove ? 754 : smAbove ? 520 : "100%";
    const routeParams = {
        label: label || "",
        folder: folder || "inbox"
    };
    (0,react.useEffect)(()=>{
        // @ts-ignore
        dispatch((0,email/* fetchMails */.d7)({
            q: query || "",
            folder: routeParams.folder,
            label: routeParams.label
        }));
    }, [
        dispatch,
        query,
        routeParams.folder,
        routeParams.label
    ]);
    const toggleComposeOpen = ()=>setComposeOpen(!composeOpen);
    const handleLeftSidebarToggle = ()=>setLeftSidebarOpen(!leftSidebarOpen);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            width: "100%",
            display: "flex",
            borderRadius: 1,
            overflow: "hidden",
            position: "relative",
            boxShadow: skin === "bordered" ? 0 : 6,
            ...skin === "bordered" && {
                border: "1px solid ".concat(theme.palette.divider)
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(email_SidebarLeft, {
                store: store,
                hidden: hidden,
                lgAbove: lgAbove,
                dispatch: dispatch,
                mailDetailsOpen: mailDetailsOpen,
                leftSidebarOpen: leftSidebarOpen,
                leftSidebarWidth: leftSidebarWidth,
                toggleComposeOpen: toggleComposeOpen,
                setMailDetailsOpen: setMailDetailsOpen,
                handleSelectAllMail: email/* handleSelectAllMail */.ER,
                handleLeftSidebarToggle: handleLeftSidebarToggle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(email_MailLog, {
                query: query,
                store: store,
                hidden: hidden,
                lgAbove: lgAbove,
                dispatch: dispatch,
                setQuery: setQuery,
                direction: direction,
                updateMail: email/* updateMail */.AS,
                routeParams: routeParams,
                labelColors: labelColors,
                paginateMail: email/* paginateMail */.zM,
                getCurrentMail: email/* getCurrentMail */.xg,
                updateMailLabel: email/* updateMailLabel */.dJ,
                mailDetailsOpen: mailDetailsOpen,
                handleSelectMail: email/* handleSelectMail */.el,
                setMailDetailsOpen: setMailDetailsOpen,
                handleSelectAllMail: email/* handleSelectAllMail */.ER,
                handleLeftSidebarToggle: handleLeftSidebarToggle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(email_ComposePopup, {
                mdAbove: mdAbove,
                composeOpen: composeOpen,
                composePopupWidth: composePopupWidth,
                toggleComposeOpen: toggleComposeOpen
            })
        ]
    });
};
/* harmony default export */ var Email = (EmailAppLayout);

;// CONCATENATED MODULE: ./src/pages/apps/email/index.js
// ** Demo Components Imports


const EmailApp = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Email, {
        folder: "inbox"
    });
EmailApp.contentHeightFixed = true;
/* harmony default export */ var apps_email = (EmailApp);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1954,518,2607,6664,8863,1664,1964,6853,7891,5294,1558,2202,1025,2709,9774,2888,179], function() { return __webpack_exec__(53765); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);